import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'reactstrap';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
// core components
const PlayerModal = ({
  show,
  children,
  onModalToggle,
  title = '',
  subtitle = '',
  showCloseButton = true,
  modalContainerClasses = '',
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    onModalToggle(open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const toggleModal = () => setOpen(!open);

  return (
    <>
      <Modal
        className={`modal-dialog-centered ${modalContainerClasses}`}
        isOpen={open}
        toggle={() => toggleModal()}
        {...props}
      >
        <div className="modal-header" style={{ display: 'none' }}>
          <h6 className="modal-title" id="modal-title-default">
            {title}
            <br />
            <p>{subtitle}</p>
          </h6>

          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setOpen(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body" style={{ padding: '0rem' }}>
          {children}

          <div className="modal-footer" style={{ display: 'none' }}>
            {showCloseButton && (
              <Button
                style={buttonStyle(
                  systemConfiguration.cancelation_button_color
                )}
                className="ml-auto"
                data-dismiss="modal"
                type="button"
                onClick={() => toggleModal()}
              >
                Fechar
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PlayerModal;
